<div class="flex items-center justify-center w-full" [ngClass]="{
    'flex-col xl:flex-row': legendPosition === 'right',
    'flex-col xl:flex-row-reverse': legendPosition === 'left',
    'flex-col': legendPosition === 'bottom'
  }">
  <!-- Chart Area -->
  <div class="relative flex items-center justify-center">
    <div class="chart-area w-full max-w-[500px]" [style.height.px]="height" [style.min-height.px]="minHeight"
      #chartContainer></div>

    @if (centerTitle || centerValue) {
    <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
      @if (centerTitle) {
      <span class="text-xs lg:text-sm text-slate-500 dark:text-slate-400 whitespace-nowrap">{{ centerTitle }}</span>
      }
      @if (centerValue) {
      <span class="text-xl lg:text-2xl font-bold text-slate-800 dark:text-white mt-1">{{ centerValue }}</span>
      }
    </div>
    }
  </div>

  <!-- Legend Area -->
  @if (showLegend) {
  <div class="flex flex-wrap gap-y-2 gap-x-6" [ngClass]="{
      'justify-start pr-4 xl:flex-col xl:items-start xl:justify-start xl:px-6': legendPosition === 'right' || legendPosition === 'left',
      'w-full justify-center mt-4': legendPosition === 'bottom',
      'w-full justify-center mt-2': legendPosition === 'top'
    }">
    @for (item of displayData; track item.label) {
    <div class="flex items-center gap-2">
      <div [style]="
          legendShape === 'circle'
            ? 'height: 10px; width: 10px; border-radius: 50%'
            : 'height: 12px; width: 16px; border-radius: 2px'
        " [style.background-color]="item.color"></div>
      <div class="flex items-center gap-1.5" [style.color]="legendTextColor ? legendTextColor : item.color">
        <span class="text-[13px] font-medium whitespace-nowrap">{{ item.label }}@if( showLegendValue){:}
        </span>
        @if(showLegendValue){
        <span class="text-[12px] font-bold">{{ item.value | number }}</span>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
